module.exports = "//static.hsappstatic.net/salesImages/static-1.403/outlook/imgs/onboarding/sales-tools.png"